import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EGeoActionType } from './types';

export const setRegionId = actionGenerator<EGeoActionType.SetRegionId, number>(EGeoActionType.SetRegionId);
